// removed by extract-text-webpack-plugin
module.exports = {"menu-bar":"_3myHwLj3","menuBar":"_3myHwLj3","left":"_3GdV76zy","full-name":"_2Ci_qoxX","fullName":"_2Ci_qoxX","right":"_36SzeYip","home-icon":"_1TN52H11","homeIcon":"_1TN52H11","showFullName":"_2fFERAwo","initials":"_2wqIsJ5K"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MenuBar/MenuBar.pcss
// module id = 1018
// module chunks = 0